module.exports = __webpack_public_path__ + "img/ecommerce-web-page-rafiki@2x.24c88599.png";